module.exports = __webpack_public_path__ + "img/mail.e3b5f40e.svg";